import _ from 'lodash'

export function findSize (department) {
  return department.styles.find(next => next.isSize)
}

export function findStyle (department) {
  return department.styles.find(next => !next.isSize)
}

export function availableStyles (department) {
  return department.styles.reduce((acc, style) => ({
    ...acc,
    [style.id]: style.options.map(next => next.id)
  }), {})
}

export function hasStyleOption (styleId, optionId, department) {
  const styles = _.get(department, 'styles', []).find(next => next.id === styleId)
  return _.get(styles, 'options', []).find(next => next.id === optionId)
}

export function availableCategories (menuBlob) {
  return _.get(menuBlob, 'departments', [])
    .map(department => department.categories.map(it => ({ ...it, departmentId: department.id })))
    .reduce((acc, it) => [...acc, ...it], [])
}

export function availableItems (menuBlob) {
  return _.get(menuBlob, 'departments', [])
    .map(department => department.items.map(it => ({ ...it, departmentId: department.id })))
    .reduce((acc, it) => [...acc, ...it], [])
}

export function availableCategoriesIds (menuBlob) {
  return availableCategories(menuBlob).map(it => it.id)
}

export function availableItemsIds (menuBlob) {
  return availableItems(menuBlob).map(it => it.id)
}
